import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "How does Altin Link work?",
    a: "We act as a professional commercial bridge between buyers, sellers, manufacturers and investors. After an initial confidential consultation we structure a requirement brief, screen qualified partners from our verified network and facilitate the introduction, negotiation and follow-up until a productive partnership is established.",
  },
  {
    q: "Which countries do you serve?",
    a: "From our Istanbul base we operate across Türkiye, Europe, the Middle East, the GCC, North Africa and Central Asia, with active engagements reaching the Americas and Asia Pacific.",
  },
  {
    q: "Do you verify suppliers?",
    a: "Yes. We perform structured supplier vetting — company registration checks, references, capacity validation and, where required, on-site factory visits — before introducing any counterpart to a client.",
  },
  {
    q: "Can you represent buyers?",
    a: "Absolutely. We act on behalf of corporate buyers to source, qualify and negotiate with manufacturers and distributors, ensuring favourable terms and reliable supply.",
  },
  {
    q: "Can you represent manufacturers?",
    a: "Yes. Manufacturers engage us to expand into new markets, identify distributors and corporate buyers, and develop long-term commercial channels in our regions of operation.",
  },
  {
    q: "Do you sign NDAs?",
    a: "Confidentiality is core to our practice. We sign mutual non-disclosure agreements before any sensitive commercial information, identity or pricing details are exchanged.",
  },
  {
    q: "How long does a business matching process take?",
    a: "Timelines depend on industry and specification depth. Typical introductions happen within 2–4 weeks, while complex multi-party deals or supplier qualifications may take 2–3 months end-to-end.",
  },
  {
    q: "How do I start working with Altin Link?",
    a: "The first step is a complimentary consultation. Reach out via the contact form, phone or email and we will schedule a confidential discovery call within 24 business hours.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-4"
          >
            <div className="lg:sticky lg:top-28">
              <div className="flex items-center gap-3 mb-6">
                <span className="gold-divider" />
                <span className="overline">FAQ</span>
              </div>
              <h2 className="font-serif-display text-4xl md:text-5xl leading-[1.05] text-altin-ink tracking-tight">
                Questions <br />
                we hear <span className="italic text-altin-gold">often</span>.
              </h2>
              <p className="mt-6 text-altin-muted leading-relaxed max-w-md">
                Practical answers to the questions companies most frequently
                raise before engaging with us.
              </p>
            </div>
          </motion.div>

          <div className="lg:col-span-8">
            <Accordion
              type="single"
              collapsible
              className="w-full border-t border-altin-border"
              data-testid="faq-accordion"
            >
              {faqs.map((f, i) => (
                <AccordionItem
                  key={f.q}
                  value={`item-${i}`}
                  className="border-b border-altin-border"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="py-6 text-left text-lg md:text-xl font-serif-display text-altin-ink hover:text-altin-gold hover:no-underline tracking-tight">
                    <span className="flex items-baseline gap-5 pr-4">
                      <span className="text-xs tracking-[0.25em] text-altin-gold shrink-0">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      {f.q}
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="text-base text-altin-muted leading-relaxed pl-12 pr-4 pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
